import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth/AuthState";
import React, { useEffect } from "react";
import { Loader2 } from "lucide-react";
import AlertPage from "../../pages/AlertPage";
import { useData } from "../context/data/DataState";

const RequireAuth = () => {
  let navigate = useNavigate();
  const { currentUser, userExist } = useAuth();
  const { data } = useData();

  useEffect(() => {
    if (currentUser && userExist === false)
      navigate("/signup", { replace: true });
  }, [currentUser, userExist]);

  const location = useLocation();

  return currentUser === 0 ||
    (currentUser && userExist === 0) ||
    (currentUser && userExist && data === 0) ? (
    <div className="flex items-center justify-center min-h-screen">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  ) : userExist === 1 || data === 1 ? (
    <AlertPage msg="Couldn't Connect to server" severity="error" />
  ) : Boolean(currentUser) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
